import React, { useState, useEffect } from "react";
import { BASE_URL } from "../env";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider, {
	CSVExport,
	Search,
} from "react-bootstrap-table2-toolkit";

const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

const CodingexamResults = () => {
	const [courseData, setCourseData] = useState([]);
	const [tabledata, settabledata] = useState([]);

	useEffect(() => {
		fetch(BASE_URL + "/getAllexam")
			.then((res) => res.json())
			.then((data) => {
				console.log(data);
				setCourseData(data?.data);
			});
	}, []);

	useEffect(() => {
		let newdata = [];

		for (var i = 0; i < courseData.length; i++) {
			newdata.push({
				sno: i + 1,
				examname: courseData[i],
				time: courseData[i]?.timer,
				questions: courseData[i]?.questions.length,
				// id: courseData[i]?.courseid._id,
				coursename: courseData[i],
			});
		}
		settabledata(newdata);
		console.log(JSON.stringify(newdata));
	}, [courseData]);

	let priceFilter;

	const columns = [
		{
			dataField: "sno",
			text: "S no.",
			sort: true,
			headerStyle: () => {
				return {
					width: "5%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
		},

		{
			dataField: "coursename",
			text: "Course Name",
			sort: true,
			formatter: (cell) => (
				<a href={`/score/${cell._id}`}> {cell?.courseid?.name} </a>
			),

			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "examname",
			text: "Exam Name",
			sort: true,
			formatter: (cell) => (
				<a href={`/score/${cell._id}`}> {cell.name} </a>
			),
			filter: textFilter({
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "questions",
			text: "Total Questions",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
		{
			dataField: "time",
			text: "Total Time",
			sort: true,
			filter: textFilter({
				getFilter: (filter) => {
					priceFilter = filter;
				},
				style: {
					height: "5px",
				},
			}),
			headerStyle: () => {
				return {
					width: "10%",
					backgroundColor: "#133d6a",
					textAlign: "center",
				};
			},
		},
	];

	const [rowcount, setRowcount] = useState(tabledata.length);
	const handleDataChange = ({ dataSize }) => {
		setRowcount(dataSize);
	};

	const numberStyle = {
		border: "2px solid black",
		boxShadow: "4px 4px rgba(93, 93, 93)",
		borderRadius: "20px",
		fontFamily: "Poppins-Bold",
		color: "white",
	};

	return (
		<div style={{ margin: "20px" }}>
			<h1 style={{ textAlign: "center", fontWeight: "900" }}>
				Coding Exams
			</h1>
			<div className="mx-2 w-25 p-3 bg-dark " style={numberStyle}>
				Row Count:<span style={{ color: "yellow" }}>{rowcount}</span>
			</div>
			<ToolkitProvider
				keyField={"sno"}
				data={tabledata}
				columns={columns}
				exportCSV={{
					fileName: "codingexam_results.csv",
					blobType: "text/csv;charset=ansi",
					onlyExportFiltered: true,
					exportAll: false,
				}}
				search
			>
				{(props) => (
					<div>
						<div className="d-flex justify-content-between">
							<ExportCSVButton
								{...props.csvProps}
								className="btn btn-md bg-warning my-2 "
								style={{
									borderRadius: "10px",
									marginLeft: "20px",
								}}
							>
								Download All Data
							</ExportCSVButton>
							<SearchBar
								{...props.searchProps}
								style={{
									width: "300px",
									height: "5px",
									marginRight: "20px",
								}}
							/>
						</div>
						<br />
						<BootstrapTable
							{...props.baseProps}
							filter={filterFactory()}
							onDataSizeChange={handleDataChange}
							// condensed
							bootstrap4
							loading
							// classes="text-white"
							striped
						/>
					</div>
				)}
			</ToolkitProvider>
		</div>
	);
};

export default CodingexamResults;
